import { GraphSchema } from '@camelot/server';

import { CurrentUser } from './current-user';

export interface User extends CurrentUser {
  isDisabled: boolean;
}

export interface UserFunctionPayload {
  userId: string;
  functionId: string;
}

export const userProps = new GraphSchema<User>([
  'id',
  'userName',
  'firstName',
  'lastName',
  'phoneNumber',
  'isCompany',
  'isDisabled',
  'culture',
  'trigram',
  'picture',
  'pictureDocumentId',
  'tenantInformations',
  'functions',
  'permissions',
]);
